// extracted by mini-css-extract-plugin
export default {"button":"Q85A9jAO","button__loading":"Of_fvfdW","buttonLoading":"Of_fvfdW","button-loading-spinner":"_3CzCBQmD","buttonLoadingSpinner":"_3CzCBQmD"};